import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const CourseLink = (props) => {
  let title = props.course.title;
  if (props.course.category === 'training') {
    title += ' Course';
  }
  return (
    <li key={props.course.id}>
      <Link to={'/courses/' + props.course.slug}>{title}</Link>
    </li>
  )
}

CourseLink.propTypes = {
  course: PropTypes.object
};

export default CourseLink;



// WEBPACK FOOTER //
// ./src/components/CourseLink/index.js